import { call, put } from "redux-saga/effects";
import Api from '../../Api';
import {setPaymentRequest, updateTransactions} from './../actions/index';

export function* fetchPaymentRequest(uuid) {
    try {
        const {data} = yield call(Api.GET_PAYMENT_REQUEST, {uuid});

        if(data.paymentRequest) {
            yield put(setPaymentRequest(data.paymentRequest));
        }

        if(data.transactions) {
            yield put(updateTransactions(data.transactions));
        }
    } catch(error) {
        yield put(setPaymentRequest({status: "something-went-wrong"}));
        console.error(error);
    }
}
